<template>
  <el-container>
    <div class="add-container" v-if="merchantList != null && merchantList.length === 0">
      <div class="add-tips">您的账号下面没有任何商家,是否需要创建一个?</div>
      <el-button class="add-button" size="big" type="primary" @click="addMerchantAction">新建商家</el-button>
    </div>
    <el-aside v-if="currentMerchant !== null" style="background-color: #f5f7f9">
      <template>
        <div style="width: 15rem; height: 6rem; align-items: center; justify-content: center; display: flex">
          <el-image class="merchant-logo" :src="currentMerchant.logo" fit="cover"/>
          <div class="merchant-name">{{currentMerchant.name}}</div>
        </div>
      </template>
      <el-col>
        <el-menu :default-active="$route.path" :router="true">
          <el-submenu v-for="(item, index) in menus" :index="item.path" :key="'m_' + index">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span class="menu-name">{{item.name}}</span>
            </template>
            <el-menu-item v-for="(subItem, subIndex) in item.subMenus" class="text-font" :key="item.code + '_' + subIndex" :index="subItem.path" >{{subItem.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-aside>
    <el-container v-if="currentMerchant !== null">
      <el-header>
        <nav-bar @switchMerchant="showSwitchMerchant=true"
                 @addMerchant="addMerchantAction"
                 @feedback="showFeedbackDialog=true"
                 @modifyPassword="showUpdatePswDialog=true;this.$refs.updatePswView && this.$refs.updatePswView.reset()"
                 @logout="logout"/>
      </el-header>
      <el-main>
        <el-tabs v-model="currentTab" type="card" closable @tab-remove="removeTab">
          <el-tab-pane
            v-for="(item, index) in tabs"
            :key="'tab_' + index"
            :label="item.meta.title"
            :name="item.path"
          />
        </el-tabs>
        <keep-alive>
          <router-view/>
        </keep-alive>
      </el-main>
    </el-container>
    <el-dialog :visible.sync="showSwitchMerchant" width="30%" title="切换商家" >
      <switch-merchant :merchant-list="merchantList" @switchSuccess="switchMerchantSuccess"/>
    </el-dialog>
    <el-dialog :title="addOrEditMerchantTitle" :visible.sync="showMerchantEditView" width="50%">
      <add ref="addMerchantView" @success="addMerchantSuccess"/>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="showUpdatePswDialog" width="30%" :destroy-on-close="true">
      <update-psw ref="updatePswView" @dismiss="showUpdatePswDialog=false"/>
    </el-dialog>
    <el-dialog title="反馈" :visible.sync="showFeedbackDialog" :destroy-on-close="true">
      <feedback  @dismiss="showFeedbackDialog=false"/>
    </el-dialog>
  </el-container>
</template>

<script>

import {home} from './homeApi'
import Add from '../merchant/add'
import NavBar from '../navBar/navBar'
import SwitchMerchant from './switchMerchant'
import {logout} from '../Login/loginApi'
import UpdatePsw from '../Login/updatePsw'
import Feedback from './feedback'

export default {
  name: 'index',
  components: {Feedback, UpdatePsw, SwitchMerchant, NavBar, Add},
  data () {
    return {
      showAddView: false,
      merchantList: null,
      currentMerchant: null,
      addOrEditMerchantTitle: '新建商家',
      showMerchantEditView: false,
      tabs: [],
      currentTab: 0,
      menus: [],
      showSwitchMerchant: false,
      showUpdatePswDialog: false,
      showFeedbackDialog: false
    }
  },
  created () {
    this.homeInfo()
    const matched = this.$route.matched.filter(item => item.name)
    if (matched.length > 1) {
      this.tabs.push(matched[matched.length - 1])
      this.currentTab = matched[matched.length - 1].path
    }
  },
  watch: {
    $route () {
      this.menuSelect()
    },
    currentTab () {
      if (this.tabs.length === 0) {
        return
      }
      this.$router.replace(this.currentTab)
    }
  },
  methods: {
    homeInfo () {
      const loading = this.$loading({
        lock: true,
        text: '获取信息中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      home().then(rsp => {
        loading.close()
        const {code, message, result} = rsp
        if (code === 0) {
          this.showAddView = result.length === 0
          let tempCurrentMerchant = null
          for (let i = 0; i < result.length; i++) {
            const tempMerchant = result[i]
            const { currentMerchant } = tempMerchant
            if (currentMerchant === true) {
              tempCurrentMerchant = tempMerchant
              break
            }
          }
          this.currentMerchant = tempCurrentMerchant
          if (tempCurrentMerchant) {
            this.menus = tempCurrentMerchant.menus
          } else {
            this.menus = []
          }
          this.merchantList = result
        } else {
          this.$message.error(message)
        }
      })
    },
    logout () {
      const logoutAction = () => {
        logout().then(rsp => {
          window.location.href = window.location.protocol + '//' + window.location.host + '/login'
        })
      }
      this.$confirm('确定要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(logoutAction).catch(null)
    },
    switchMerchantSuccess () {
      this.showSwitchMerchant = false
      location.reload()
    },
    addMerchantAction () {
      this.showMerchantEditView = true
      this.$refs.addMerchantView && this.$refs.addMerchantView.reset()
    },
    addMerchantSuccess () {
      this.showMerchantEditView = false
      location.reload()
    },
    removeTab (v) {
      let matchIndex = null
      for (let i = 0; i < this.tabs.length; i++) {
        const tempItem = this.tabs[i]
        if (tempItem.path === v) {
          matchIndex = i
          break
        }
      }
      if (matchIndex === null) {
        return
      }
      if (this.$route.path === v) {
        if (this.tabs.length === 1) {
          this.$router.replace('/home')
          this.tabs = []
          return
        } else {
          if (matchIndex > 0) {
            this.$router.replace(this.tabs[matchIndex - 1].path)
          } else {
            this.$router.replace(this.tabs[matchIndex - 1].path)
          }
        }
      }
      this.tabs.splice(matchIndex, 1)
    },
    menuSelect () {
      const matched = this.$route.matched.filter(item => item.name)
      if (matched.length > 1) {
        const lastItem = matched[matched.length - 1]
        for (let i = 0; i < this.tabs.length; i++) {
          if (lastItem.path === this.tabs[i].path) {
            this.currentTab = this.tabs[i].path
            return
          }
        }
        this.tabs.push(lastItem)
        this.tabs = [].concat(this.tabs)
        this.currentTab = lastItem.path
      }
    }
  }
}
</script>

<style scoped>
.add-container{
  text-align: center;
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
}
.add-tips{
  margin-top: 15rem;
  font-size: 2rem;
  font-weight: bold;
}
.add-button{
  margin-top: 2rem;
  font-size: 2rem;
}
.merchant-logo{
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.merchant-name{
  font-size: 17px;
  margin-left: 10px;
  font-weight: 600;
  color: #ff680a;
}
.menu-name{
  color: #515a6e;
  font-size: 1.2rem;
}
.text-font{
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue